// extracted by mini-css-extract-plugin
module.exports = {"screenshot":"styles_screenshot__2Xsmo","top":"styles_top__3c9H3","bottom":"styles_bottom__a3EXh"};